// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8e963e1","239":"dc665980","455":"a81ef22f"}[chunkId] + ".chunk.js";
};